createSchoolEntity.$inject = ['graph']
export default function createSchoolEntity(graph) {
  return {
    restrict: 'EA',
    scope: {
      domainUuid: '@',
      onSchoolCreated: '&'
    },
    template: require('./_createSchoolEntity.html'),
    link: function(scope) {
      scope.schoolEditInfo = {}

      // error handling
      scope.errorMessage = ''
      scope.showError = false

      scope.savingSchool = false
      scope.createSchool = function(data) {
        scope.savingSchool = true
        scope.showError = false
        graph.createSchool(scope.domainUuid, data).then(
          function(createdSchool) {
            scope.onSchoolCreated({ school: createdSchool })
            scope.savingSchool = false
          },
          function(reason) {
            scope.errorMessage = 'There was an error saving the school. ' + reason
            scope.showError = true
            scope.savingSchool = false
          }
        )
      }
    }
  }
}
